import React from "react";
import PropTypes from "prop-types";

import { useTicketTransferNewContext } from "./TicketTransferNewContainer";

const stepContainer = {
  border: "1px solid #E9EAEB",
  boxShadow: "0px 1px 2px 0px #0A0D120D",
  display: "flex",
  flexDirection: "column",
  borderRadius: "8px",
  marginBottom: "20px",
};

const headerStyle = {
  padding: "20px",
  borderBottom: "1px solid #E9EAEB",
  fontSize: "16px",
};

const subHeaderStyle = {
  padding: "20px",
  borderBottom: "1px solid #E9EAEB",
  fontSize: "14px",
  fontWeight: "bold",
};

const selectControlStyle = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  padding: "20px",
  backgroundColor: "#FAFAFA", 
  borderBottom: "1px solid #E9EAEB",
};

const selectAllStyle = {
  display: "flex",
  gap: "8px",
  color: "#717680",
  fontWeight: 500,
  fontSize: 12,
  alignItems: "center",
};

const deselectStyle = {
  cursor: "pointer",
  fontSize: 12,
  fontWeight: 500,
};

const ticketRowStyle = {
  display: "flex",
  padding: "20px",
  borderBottom: "1px solid #E9EAEB",
  gap: "8px",
  color: "#3333333",
  cursor: "pointer",
};

const footerStyle = {
  display: "flex",
  justifyContent: "flex-end",
  padding: "20px",
};

const nextButtonStyle = {
  borderRadius: "8px",
  border: "1px solid #E9EAEB",
  padding: "5px 10px",
  fontWeight: 500,
};

const formatPrice = (price) => {
  return Number(price).toFixed(2);
};

const TicketSelect = () => {
  const {
    transferableTickets,
    transferableAddOns,
    setStep,
    ticketIds,
    setTicketIds,
  } = useTicketTransferNewContext();

  const toggleTicket = (ticketId) => {
    if (ticketIds.includes(ticketId)) {
      setTicketIds(ticketIds.filter((id) => id !== ticketId));
    } else {
      setTicketIds([...ticketIds, ticketId]);
    }
  };

  const allTransferableIds = [
    ...transferableTickets.map((t) => t.id),
    ...transferableAddOns.map((a) => a.id),
  ];

  const sortedTransferableTickets = transferableTickets.sort((a, b) => {
    return a.seat_assignment?.localeCompare(b.seat_assignment);
  });

  const pairedSeatByTicketId = Object.fromEntries(
    transferableAddOns.filter((a) => a.paired_ticket_id && a.seat_assignment).map((a) => [a.paired_ticket_id, a.seat_assignment])
  );

  const sortedTransferableAddOns = transferableAddOns.sort((a, b) => {
    return a.product_name?.localeCompare(b.product_name);
  });

  return (
    <div style={stepContainer}>
      <div style={headerStyle}>
        Choose your tickets
      </div>
      <div style={selectControlStyle}>
        <div style={selectAllStyle}>
          <input type="checkbox"
            checked={ticketIds.length === allTransferableIds.length}
            onChange={() => {
              if (ticketIds.length === allTransferableIds.length) {
                setTicketIds([]);
              } else {
                setTicketIds(allTransferableIds);
              }
            }}
          />
          <div>Select All</div>
        </div>
        <div style={{
          ...deselectStyle,
          color: ticketIds.length ? "#000000" : "#00000080",
        }}
          onClick={() => setTicketIds([])}
        >Deselect</div>
      </div>

      {sortedTransferableTickets.length > 0 && (
        <>
          <div style={subHeaderStyle}>Tickets</div>
          {sortedTransferableTickets.map((ticket, index) => (
            <div key={index} style={ticketRowStyle} onClick={() => toggleTicket(ticket.id)}>
              <input
                type="checkbox"
                checked={ticketIds.includes(ticket.id)}
                onChange={() => toggleTicket(ticket.id)}
              />
              <div>
                <div>{ticket.product_name}{!!ticket.seat_assignment ? ` - ${ticket.seat_assignment} - ` : " - "}${formatPrice(ticket.face_value)}</div>
                {pairedSeatByTicketId[ticket.id] && (
                  <div style={{ fontSize: "13px", color: "#666666" }}>Reserved seat: {pairedSeatByTicketId[ticket.id]}</div>
                )}
              </div>
            </div>
          ))}
        </>
      )}

      {sortedTransferableAddOns.length > 0 && (
        <>
          <div style={subHeaderStyle}>Add-Ons</div>
          {sortedTransferableAddOns.map((addOn, index) => (
            <div key={index} style={ticketRowStyle} onClick={() => toggleTicket(addOn.id)}>
              <input
                type="checkbox"
                checked={ticketIds.includes(addOn.id)}
                onChange={() => toggleTicket(addOn.id)}
              />
              <div>
                <div>{addOn.product_name} - ${formatPrice(addOn.face_value)}</div>
                {addOn.entry_label && (
                  <div style={{ fontSize: "13px", color: "#666666" }}>{addOn.entry_label}</div>
                )}
              </div>
            </div>
          ))}
        </>
      )}

      <div style={footerStyle}>
        <button
          disabled={ticketIds.length === 0}
          onClick={() => {
            setStep("Enter recipient details");
          }}
          style={{
            ...nextButtonStyle,
            backgroundColor: ticketIds.length ? "#FFFFFF" : "#FAFAFA",
            color: ticketIds.length ? "#333333" : "#33333380",
          }}
        >
          Next <i className="fas fa-arrow-right" />
        </button>
      </div>
    </div>
  );
};

TicketSelect.propTypes = {};

export default TicketSelect;
